import { useSEO } from "@/hooks/useSEO";
import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/shared/Marquee";
import { WhatWeDo } from "@/components/home/WhatWeDo";
import { SolutionsGrid } from "@/components/home/SolutionsGrid";
import { TechAgnostic } from "@/components/home/TechAgnostic";
import { Architecture } from "@/components/home/Architecture";
import { IndustriesGrid } from "@/components/home/IndustriesGrid";
import { WhyWexoz } from "@/components/home/WhyWexoz";
import { Process } from "@/components/home/Process";
import { UseCases } from "@/components/home/UseCases";
import { ClosingCTA } from "@/components/home/ClosingCTA";

const MARQUEE = ["Fleet IoT", "Logistics Automation", "School Transport", "Transport CCTV", "Transportation AI", "Systems Integration", "Technology Consulting"];

export default function Home() {
  useSEO({
    title: "Wexoz | Transportation Technology Systems Integrator, Dubai",
    description: "Wexoz designs, integrates and deploys connected transportation solutions in Dubai and the UAE — fleet IoT, logistics automation, school transport, transport CCTV and AI.",
  });
  return (
    <>
      <Hero />
      <Marquee items={MARQUEE} />
      <WhatWeDo />
      <SolutionsGrid />
      <TechAgnostic />
      <Architecture />
      <IndustriesGrid />
      <WhyWexoz />
      <Process />
      <UseCases />
      <ClosingCTA />
    </>
  );
}
